import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SortableComponent from '../../common/components/SortableComponent';
import Icon from '../../common/icons/Icon';

class SortableListWrapper extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired,
    title: PropTypes.string,
    topButtons: PropTypes.object
  };

  static defaultProps = {
    title: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      sorting: false,
      items: props.items,
    };
  }

  toggleSorting = () => {
    this.setState(state => {
      const nextState = { sorting: !state.sorting };

      if (state.sorting) {
        nextState.items = this.props.items;
      }

      return nextState;
    });
  };

  onSortEnd = items => {
    this.setState({ items });
  };

  onSave = () => {
    const { items } = this.state;

    this.props.onSave(items).then(this.toggleSorting);
  };

  render() {
    const { children, title, topButtons } = this.props;
    const { items, sorting } = this.state;
    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <h3>{title}</h3>
          {sorting ? (
            <div>
              <button
                className="button button--theme--plain"
                onClick={this.toggleSorting}
              >
                Cancel
              </button>
              <button className="button" onClick={this.onSave}>
                Save Order
              </button>
            </div>
          ) : (
            <div>
              {topButtons}
              <button onClick={this.toggleSorting} className="button button--theme--plain">
                <Icon icon="Sort" />Edit Order
              </button>
            </div>
          )}
        </div>
        {sorting ? <SortableComponent items={items} onSortEnd={this.onSortEnd} /> : children}
      </div>
    );
  }
}

export default SortableListWrapper;



// WEBPACK FOOTER //
// ./src/common/components/SortableListWrapper.js